import React from "react";

import classNames from "classnames";
import dynamic from 'next/dynamic';

import { makeStyles } from "@material-ui/core/styles";
import Loading from 'components/Functions/Loading';

const Footer = dynamic(() => import('/components/Footer/Footer.js'), { loading: () => <Loading /> });

import landingPage from "/styles/jss/bbhost/pages/landingPage.js";
import teamStyle from "/styles/jss/bbhost/pages/landingPageSections/teamStyle.js";

// Sections for this page
import HeaderSection from "pages-sections/HeaderSection.js";

const AntiDDoSSection = dynamic(() => import('pages-sections/DataCenterPage-Sections/AntiDDoSSection.js'));

const GridContainer = dynamic(() => import('/components/Grid/GridContainer.js'), { loading: () => <Loading />, ssr: false });
const GridItem = dynamic(() => import('/components/Grid/GridItem.js'));
import InfoAreaFontAwesome from '/components/InfoArea/InfoAreaFontAwesome.js'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles({
  ...landingPage,
  ...teamStyle
});

const SEO = {
  title: "BB Host - Anti-DDoS",
  description: "Infraestrutura com equipamentos de ponta, para garantir a confiabilidade de toda a operação.",
  url: "https://www.bbhost.com.br/anti_ddos",
  type: "website",
  languageAlternates: [
    {
        hrefLang: 'en',
        href: "https://www.bbhost.com.br/en/anti_ddos",
    },
    {
        hrefLang: 'es',
        href: "https://www.bbhost.com.br/es/anti_ddos",
    }
  ],
};

export default function AntiDDoS(props) {
  const classes = useStyles();

  return (
    <div>
      <HeaderSection name="anti_ddos" seo={SEO} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <div className={classes.section}>
            <GridContainer justifyContent="center">
              <GridItem xs={12} sm={12} md={12}>
                <AntiDDoSSection />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <h3 className={classes.title}><FontAwesomeIcon icon={["far", "clock"]} size="sm" width={"26px"}/>{" "}Em breve</h3>
                <GridContainer justifyContent="center" alignItems="center">
                  <GridItem xs={12} sm={12} md={6}>
                    <InfoAreaFontAwesome 
                      iconColor="success" 
                      icon={["fa", "shield-halved"]} 
                      widthIcon={"16px"}
                      title="ISP Protection" 
                      description="Solução para mitigação de ataques destinado a pequenos provedores de acesso."
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <InfoAreaFontAwesome 
                      iconColor="success" 
                      icon={["fa", "shield"]} 
                      widthIcon={"16px"}
                      title="Remote Protection" 
                      description="Utilize nossa proteção em seu servidor, através de um tunnel VXLAN."
                    />
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export async function getServerSideProps({ req, res }) {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=86400, stale-while-revalidate=86400'
  );
  return {
    props: { }
  }
}